export default __webpack_public_path__ + "static/media/erth.c84f8e27.svg";